import { createActionCreator } from 'deox';

import { TCreateCheckoutSessionMaterials, TCreateCheckoutSessionResponse } from '@/services/api/company';

// CONSTANTS

export enum ECreateCheckoutSessionAction {
  CREATE_CHECKOUT_SESSION = 'CREATE_CHECKOUT_SESSION',
  CREATE_CHECKOUT_SESSION_REQUEST = 'CREATE_CHECKOUT_SESSION_REQUEST',
  CREATE_CHECKOUT_SESSION_SUCCESS = 'CREATE_CHECKOUT_SESSION_SUCCESS',
  CREATE_CHECKOUT_SESSION_FAILED = 'CREATE_CHECKOUT_SESSION_FAILED',
}

// TYPES

export type TCreateCheckoutSessionRequest = {
  type: ECreateCheckoutSessionAction.CREATE_CHECKOUT_SESSION_REQUEST;
  payload: {
    materials: TCreateCheckoutSessionMaterials;
    successCallback?: (response: TCreateCheckoutSessionResponse) => void;
    failedCallback?: (err: unknown) => void;
  };
};

export type TCreateCheckoutSessionSuccess = {
  type: ECreateCheckoutSessionAction.CREATE_CHECKOUT_SESSION_SUCCESS;
  payload: { response: TCreateCheckoutSessionResponse };
};

export type TCreateCheckoutSessionFailed = { type: ECreateCheckoutSessionAction.CREATE_CHECKOUT_SESSION_FAILED };

// FUNCTION

export const createCheckoutSessionAction = {
  request: createActionCreator(
    ECreateCheckoutSessionAction.CREATE_CHECKOUT_SESSION_REQUEST,
    (resolve) =>
      (
        materials: TCreateCheckoutSessionMaterials,
        successCallback?: (response: TCreateCheckoutSessionResponse) => void,
        failedCallback?: (err: unknown) => void,
      ): TCreateCheckoutSessionRequest =>
        resolve({ materials, successCallback, failedCallback }),
  ),
  success: createActionCreator(
    ECreateCheckoutSessionAction.CREATE_CHECKOUT_SESSION_SUCCESS,
    (resolve) =>
      (response: TCreateCheckoutSessionResponse): TCreateCheckoutSessionSuccess =>
        resolve({ response }),
  ),
  failure: createActionCreator(
    ECreateCheckoutSessionAction.CREATE_CHECKOUT_SESSION_FAILED,
    (resolve) =>
      (error: any): TCreateCheckoutSessionFailed =>
        resolve({ error }),
  ),
};
